import { Ribbon } from '@/data/types/Product';
import { extractDpOffer } from 'integration/utils/isDpOffer';

export const extractNumberFromString = (input: string) => {
	const match = input.match(/\d+/);
	return match ? parseInt(match[0], 10) : 0;
};

export const calculateProductPrices = ({
	list,
	offer,
	ribbons,
}: {
	list: number;
	offer: number;
	ribbons: Ribbon[];
}) => {
	const { offer: dpOffer, offerAdditional: dpOfferAdditional } = extractDpOffer(ribbons);

	if (dpOffer > 0 && dpOfferAdditional > 0) {
		const firstOffer = offer - offer * dpOffer;
		const finalOffer = firstOffer - firstOffer * dpOfferAdditional;

		const discount = finalOffer !== offer ? finalOffer : 0;

		return {
			priceWithoutOffer: list,
			shouldOffer: discount > 0,
			price: discount,
			additionalOffer: true,
		};
	}

	if (dpOfferAdditional > 0) {
		const finalOffer = offer - offer * dpOfferAdditional;

		const discount = finalOffer !== offer ? finalOffer : 0;

		return {
			priceWithoutOffer: list,
			shouldOffer: discount > 0,
			price: discount,
			additionalOffer: true,
		};
	}

	const discount = offer * dpOffer;
	const price = offer - discount;

	return {
		priceWithoutOffer: list,
		shouldOffer: offer > 0 && offer !== list,
		price,
		additionalOffer: dpOffer > 0,
	};
};
